var dscRegimens = {
    "darkcircles-4": {
        desc: "Layer these products in this order for best results",
        steps: [{
            name: "Cleanse",
            pid: "PRVN40149",
            tod: !1,
            rec: !1
        }, {
            name: "Prep",
            pid: "PRVN40174",
            tod: !1,
            rec: !1
        }, {
            name: "Boost",
            pid: "A0101366",
            tod: !1,
            rec: !1
        }, {
            name: "Eye",
            pid: "A0102886",
            tod: !1,
            rec: !0
        }, {
            name: "Treat",
            pid: "A0124504",
            tod: !1,
            rec: !1
        }, {
            name: "Moisturize",
            pids: [{
                name: "Day",
                pid: "PRVN00101",
                tod: "day",
                rec: !1
            }, {
                name: "Night",
                pid: "A0135583",
                tod: "night",
                rec: !1
            }]
        }]
    },
    "darkcircles-3": {
        desc: "Layer these products in this order for best results",
        steps: [{
            name: "Cleanse",
            pid: "PRVN40149",
            tod: !1,
            rec: !1
        }, {
            name: "Prep",
            pid: "PRVN40174",
            tod: !1,
            rec: !1
        }, {
            name: "Boost",
            pid: "A0101366",
            tod: !1,
            rec: !1
        }, {
            name: "Eye",
            pid: "A0102886",
            tod: !1,
            rec: !0
        }, {
            name: "Treat",
            pid: "A0124504",
            tod: !1,
            rec: !1
        }, {
            name: "Moisturize",
            pids: [{
                name: "Day",
                pid: "PRVN00101",
                tod: "day",
                rec: !1
            }, {
                name: "Night",
                pid: "A0135583",
                tod: "night",
                rec: !1
            }]
        }]
    },
    "darkcircles-2": {
        desc: "Layer these products in this order for best results",
        steps: [{
            name: "Cleanse",
            pid: "A0130794",
            tod: !1,
            rec: !1
        }, {
            name: "Eye",
            pid: "A0126296",
            tod: !1,
            rec: !0
        }, {
            name: "Boost",
            pid: "A0101366",
            tod: !1,
            rec: !1
        }, {
            name: "PM Serum",
            pid: "A0133027",
            tod: !1,
            rec: !1
        }, {
            name: "AM Serum",
            pid: "A0104589",
            tod: !1,
            rec: !1
        }, {
            name: "Moisturize",
            pids: [{
                name: "Day",
                pid: "A0127779",
                tod: "day",
                rec: !1
            }, {
                name: "Night",
                pid: "A0127780",
                tod: "night",
                rec: !1
            }]
        }]
    },
    "darkcircles-1": {
        desc: "Layer these products in this order for best results",
        steps: [{
            name: "Cleanse",
            pid: "A0130794",
            tod: !1,
            rec: !1
        }, {
            name: "Replenish",
            pid: "A0126102",
            tod: !1,
            rec: !1
        }, {
            name: "Boost",
            pid: "A0101366",
            tod: !1,
            rec: !1
        }, {
            name: "Eye",
            pid: "A0107303",
            tod: !1,
            rec: !0
        }, {
            name: "Treat",
            pid: "A0104589",
            tod: !1,
            rec: !1
        }, {
            name: "Moisturize",
            pids: [{
                name: "Day",
                pid: "A0127779",
                tod: "day",
                rec: !1
            }, {
                name: "Night",
                pid: "A0127780",
                tod: "night",
                rec: !1
            }]
        }]
    },
    "spots-4": {
        desc: "Layer these products in this order for best results",
        steps: [{
            name: "Cleanse",
            pid: "PRVN40149",
            tod: !1,
            rec: !1
        }, {
            name: "Prep",
            pid: "PRVN40174",
            tod: !1,
            rec: !1
        }, {
            name: "Boost",
            pid: "A0101366",
            tod: !1,
            rec: !1
        }, {
            name: "Treat",
            pid: "A0124504",
            tod: !1,
            rec: !0
        }, {
            name: "Moisturize",
            pids: [{
                name: "Day",
                pid: "A0100498",
                tod: "day",
                rec: !1
            }, {
                name: "Night",
                pid: "A0135583",
                tod: "night",
                rec: !1
            }]
        }]
    },
    "spots-3": {
        desc: "Layer these products in this order for best results",
        steps: [{
            name: "Cleanse",
            pid: "A0130794",
            tod: !1,
            rec: !1
        }, {
            name: "Treat",
            pid: "A0133823",
            tod: !1,
            rec: !0
        }, {
            name: "Boost",
            pid: "A0101366",
            tod: !1,
            rec: !1
        }, {
            name: "Treat",
            pid: "A0136394",
            tod: !1,
            rec: !1
        }, {
            name: "Moisturize",
            pids: [{
                name: "Day",
                pid: "A0100498",
                tod: "day",
                rec: !1
            }, {
                name: "Night",
                pid: "A0130785",
                tod: "night",
                rec: !1
            }]
        }]
    },
    "spots-2": {
        desc: "Layer these products in this order for best results",
        steps: [{
            name: "Cleanse",
            pid: "A0130794",
            tod: !1,
            rec: !1
        }, {
            name: "Replenish",
            pid: "A0126102",
            tod: !1,
            rec: !1
        }, {
            name: "Boost",
            pid: "A0101366",
            tod: !1,
            rec: !1
        }, {
            name: "Treat",
            pid: "A0119546",
            tod: !1,
            rec: !0
        }, {
            name: "Moisturize",
            pids: [{
                name: "Day",
                pid: "A0127779",
                tod: "day",
                rec: !1
            }, {
                name: "Night",
                pid: "A0127780",
                tod: "night",
                rec: !1
            }]
        }]
    },
    "spots-1": {
        desc: "Layer these products in this order for best results",
        steps: [{
            name: "Cleanse",
            pid: "A0130794",
            tod: !1,
            rec: !1
        }, {
            name: "Treat",
            pid: "A0133823",
            tod: !1,
            rec: !0
        }, {
            name: "Boost",
            pid: "A0101366",
            tod: !1,
            rec: !1
        }, {
            name: "Treat",
            pid: "A0136394",
            tod: !1,
            rec: !1
        }, {
            name: "Moisturize",
            pids: [{
                name: "Day",
                pid: "A0100498",
                tod: "day",
                rec: !1
            }, {
                name: "Night",
                pid: "A0130785",
                tod: "night",
                rec: !1
            }]
        }]
    },
    "texture-4": {
        desc: "Layer these products in this order for best results",
        steps: [{
            name: "Cleanse",
            pid: "PRVN40149",
            tod: !1,
            rec: !1
        }, {
            name: "Treat",
            pid: "A0116163",
            tod: !1,
            rec: !0
        }, {
            name: "Boost",
            pid: "A0101366",
            tod: !1,
            rec: !1
        }, {
            name: "Treat",
            pid: "A0124504",
            tod: !1,
            rec: !1
        }, {
            name: "Moisturize",
            pids: [{
                name: "Day",
                pid: "A0100498",
                tod: "day",
                rec: !1
            }, {
                name: "Night",
                pid: "A0135583",
                tod: "night",
                rec: !1
            }]
        }]
    },
    "texture-3": {
        desc: "Layer these products in this order for best results",
        steps: [{
            name: "Cleanse",
            pid: "A0130794",
            tod: !1,
            rec: !1
        }, {
            name: "Treat",
            pid: "A0133823",
            tod: !1,
            rec: !0
        }, {
            name: "Boost",
            pid: "A0101366",
            tod: !1,
            rec: !1
        }, {
            name: "Treat",
            pid: "A0136394",
            tod: !1,
            rec: !1
        }, {
            name: "Moisturize",
            pids: [{
                name: "Day",
                pid: "A0100498",
                tod: "day",
                rec: !1
            }, {
                name: "Night",
                pid: "A0130785",
                tod: "night",
                rec: !1
            }]
        }]
    },
    "texture-2": {
        desc: "Layer these products in this order for best results",
        steps: [{
            name: "Cleanse",
            pid: "A0130794",
            tod: !1,
            rec: !1
        }, {
            name: "Replenish",
            pid: "A0126102",
            tod: !1,
            rec: !1
        }, {
            name: "Boost",
            pid: "A0101366",
            tod: !1,
            rec: !1
        }, {
            name: "Treat",
            pid: "A0119561",
            tod: !1,
            rec: !0
        }, {
            name: "Moisturize",
            pids: [{
                name: "Day",
                pid: "A0127779",
                tod: "day",
                rec: !1
            }, {
                name: "Night",
                pid: "A0127780",
                tod: "night",
                rec: !1
            }]
        }]
    },
    "texture-1": {
        desc: "Layer these products in this order for best results",
        steps: [{
            name: "Cleanse",
            pid: "A0130794",
            tod: !1,
            rec: !1
        }, {
            name: "Replenish",
            pid: "A0126102",
            tod: !1,
            rec: !1
        }, {
            name: "Boost",
            pid: "A0101366",
            tod: !1,
            rec: !0
        }, {
            name: "Treat",
            pid: "A0119561",
            tod: !1,
            rec: !1
        }, {
            name: "Moisturize",
            pids: [{
                name: "Day",
                pid: "A0127779",
                tod: "day",
                rec: !1
            }, {
                name: "Night",
                pid: "A0127780",
                tod: "night",
                rec: !1
            }]
        }]
    },
    "wrinkles-4": {
        desc: "Layer these products in this order for best results",
        steps: [{
            name: "Cleanse",
            pid: "CERN40117",
            tod: !1,
            rec: !1
        }, {
            name: "Replenish",
            pid: "A0126102",
            tod: !1,
            rec: !1
        }, {
            name: "Boost",
            pid: "A0101366",
            tod: !1,
            rec: !1
        }, {
            name: "PM Serum",
            pid: "A0133027",
            tod: !1,
            rec: !0
        }, {
            name: "AM Serum",
            pid: "A0104589",
            tod: !1,
            rec: !1
        }, {
            name: "Moisturize",
            pids: [{
                name: "Day",
                pid: "A0127779",
                tod: "day",
                rec: !1
            }, {
                name: "Night",
                pid: "A0127780",
                tod: "night",
                rec: !1
            }]
        }]
    },
    "wrinkles-3": {
        desc: "Layer these products in this order for best results",
        steps: [{
            name: "Cleanse",
            pid: "CERN40117",
            tod: !1,
            rec: !1
        }, {
            name: "Replenish",
            pid: "A0126102",
            tod: !1,
            rec: !1
        }, {
            name: "Boost",
            pid: "A0101366",
            tod: !1,
            rec: !1
        }, {
            name: "PM Serum",
            pid: "A0133027",
            tod: !1,
            rec: !0
        }, {
            name: "AM Serum",
            pid: "A0104589",
            tod: !1,
            rec: !1
        }, {
            name: "Moisturize",
            pids: [{
                name: "Day",
                pid: "A0127779",
                tod: "day",
                rec: !1
            }, {
                name: "Night",
                pid: "A0127780",
                tod: "night",
                rec: !1
            }]
        }]
    },
    "wrinkles-2": {
        desc: "Layer these products in this order for best results",
        steps: [{
            name: "Cleanse",
            pid: "PRVN40149",
            tod: !1,
            rec: !1
        }, {
            name: "Prep",
            pid: "PRVN40174",
            tod: !1,
            rec: !1
        }, {
            name: "Boost",
            pid: "A0101366",
            tod: !1,
            rec: !1
        }, {
            name: "Treat",
            pid: "A0124504",
            tod: !1,
            rec: !0
        }, {
            name: "Moisturize",
            pids: [{
                name: "Day",
                pid: "PRVN00101",
                tod: "day",
                rec: !1
            }, {
                name: "Night",
                pid: "A0135583",
                tod: "night",
                rec: !1
            }]
        }]
    },
    "wrinkles-1": {
        desc: "Layer these products in this order for best results",
        steps: [{
            name: "Cleanse",
            pid: "CERN40117",
            tod: !1,
            rec: !1
        }, {
            name: "Replenish",
            pid: "A0126102",
            tod: !1,
            rec: !1
        }, {
            name: "Boost",
            pid: "A0101366",
            tod: !1,
            rec: !1
        }, {
            name: "Treat",
            pid: "A0104589",
            tod: !1,
            rec: !0
        }, {
            name: "Moisturize",
            pids: [{
                name: "Day",
                pid: "A0127779",
                tod: "day",
                rec: !1
            }, {
                name: "Night",
                pid: "A0127780",
                tod: "night",
                rec: !1
            }]
        }]
    },
    "firmness-4": {
        desc: "Layer these products in this order for best results",
        steps: [{
            name: "Cleanse",
            pid: "PRVN40149",
            tod: !1,
            rec: !1
        }, {
            name: "Essence",
            pid: "A0123613",
            tod: !1,
            rec: !1
        }, {
            name: "Probiotic Boost",
            pid: "A0101366",
            tod: !1,
            rec: !1
        }, {
            name: "Serum",
            pid: "A0124504",
            tod: !1,
            rec: !0
        }, {
            name: "Moisturize",
            pids: [{
                name: "Day",
                pid: "PRVN00101",
                tod: "day",
                rec: !1
            }, {
                name: "Night",
                pid: "A0135583",
                tod: "night",
                rec: !1
            }]
        }]
    },
    "firmness-3": {
        desc: "Layer these products in this order for best results",
        steps: [{
            name: "Cleanse",
            pid: "CERN40117",
            tod: !1,
            rec: !1
        }, {
            name: "Replenish",
            pid: "A0123613",
            tod: !1,
            rec: !1
        }, {
            name: "Probiotic Boost",
            pid: "A0101366",
            tod: !1,
            rec: !1
        }, {
            name: "Serum",
            pid: "A0104589",
            tod: !1,
            rec: !0
        }, {
            name: "Moisturize",
            pids: [{
                name: "Day",
                pid: "A0127779",
                tod: "day",
                rec: !1
            }, {
                name: "Night",
                pid: "A0127780",
                tod: "night",
                rec: !1
            }]
        }]
    },
    "firmness-2": {
        desc: "Layer these products in this order for best results",
        steps: [{
            name: "Cleanse",
            pid: "A0130794",
            tod: !1,
            rec: !1
        }, {
            name: "Replenish",
            pid: "A0123613",
            tod: !1,
            rec: !1
        }, {
            name: "Probiotic Boost",
            pid: "A0101366",
            tod: !1,
            rec: !1
        }, {
            name: "Serum",
            pid: "A0119561",
            tod: !1,
            rec: !0
        }, {
            name: "Moisturize",
            pids: [{
                name: "Day",
                pid: "A0127779",
                tod: "day",
                rec: !1
            }, {
                name: "Night",
                pid: "A0127780",
                tod: "night",
                rec: !1
            }]
        }]
    },
    "firmness-1": {
        desc: "Layer these products in this order for best results",
        steps: [{
            name: "Cleanse",
            pid: "A0130794",
            tod: !1,
            rec: !1
        }, {
            name: "Replenish",
            pid: "A0123613",
            tod: !1,
            rec: !1
        }, {
            name: "Probiotic Boost",
            pid: "A0101366",
            tod: !1,
            rec: !1
        }, {
            name: "Serum",
            pid: "A0104589",
            tod: !1,
            rec: !1
        }, {
            name: "Moisturize",
            pids: [{
                name: "Day",
                pid: "A0127779",
                tod: "day",
                rec: !0
            }, {
                name: "Night",
                pid: "A0127780",
                tod: "night",
                rec: !1
            }]
        }]
    }, 1: {
        desc: "Layer these products in this order for best results",
        steps: [{
            name: "Cleanse",
            pid: "PRVN40149",
            tod: !1,
            rec: !1
        }, {
            name: "Prep",
            pid: "PRVN40174",
            tod: !1,
            rec: !1
        }, {
            name: "Boost",
            pid: "A0101366",
            tod: !1,
            rec: !1
        }, {
            name: "Treat",
            pid: "A0124504",
            tod: !1,
            rec: !0
        }, {
            name: "Moisturize",
            pids: [{
                name: "Day",
                pid: "PRVN00101",
                tod: "day",
                rec: !1
            }, {
                name: "Night",
                pid: "A0135583",
                tod: "night",
                rec: !1
            }]
        }]
    }
}, dscProds = {
    A0104589: {
        name: "Advanced Ceramide Capsules Daily Youth Restoring Serum",
        brand: "Ceramide",
        desc: "Pure. Potent. Precise. Our ceramide serum has triple the anti-aging power for visibly firmer, smoother, healthy-looking skin.",
        size: "90-Piece",
        price: "109",
        pid: "A0104589"
    }, A0104588: {
        name: "Advanced Ceramide Capsules Daily Youth Restoring Serum",
        brand: "Ceramide",
        desc: "Pure. Potent. Precise. Our ceramide serum has triple the anti-aging power for visibly firmer, smoother, healthy-looking skin.",
        size: "60-Piece",
        price: "88",
        pid: "A0104588"
    }, A0104591: {
        name: "Advanced Ceramide Capsules Daily Youth Restoring Serum",
        brand: "Ceramide",
        desc: "Pure. Potent. Precise. Our ceramide serum has triple the anti-aging power for visibly firmer, smoother, healthy-looking skin.",
        size: "30-Piece",
        price: "50",
        pid: "A0104591"
    }, A0107303: {
        name: "Advanced Ceramide Capsules Daily Youth Restoring Eye Serum",
        brand: "Ceramide",
        desc: "A lot of action from a little twist. NEW Advanced Ceramide Capsules Daily Youth Restoring Eye Serum visibly firms and reduces the look of crow's feet and puffiness1 for eyes that look younger and brighter.",
        size: "60-Piece",
        price: "67",
        pid: "A0107303"
    }, A0127779: {
        name: "Advanced Ceramide Lift and Firm Day Cream SPF 15",
        brand: "Ceramide",
        desc: "Advanced Ceramide Lift and Firm Day Cream is an anti-aging cream with 5x the Ceramide. Features 3D FIT Technology with to firm, intensely hydrate and tighten. 1 week to visibly lifted, firmer and more defined facial contours.",
        size: "1.7 oz.",
        price: "86",
        pid: "A0127779"
    }, A0127780: {
        name: "Advanced Ceramide Lift and Firm Night Cream",
        brand: "Ceramide",
        desc: "Advanced Ceramide Lift and Firm Night Cream is an anti-aging cream with 5x the Ceramide. Features 3D FIT Technology with Ceramides, Tetrapeptides and Edelweiss Extract2 to Firm, Intensely Hydrate and Tighten. 1 week to visibly lifted, firmer and more defined facial contours.",
        size: "1.7 oz.",
        price: "88",
        pid: "A0127780"
    }, A0126102: {
        name: "Ceramide Micro Capsule Skin Replenishing Essence",
        brand: "Ceramide",
        desc: "Nourish, smooth and visibly clarify skin with a water-light, microencapsulated essence that prepares skin for rest of your beauty routine. In one week, 96% saw crystal clear skin with visibly improved texture and vitality.",
        size: "4.7 oz.",
        price: "82",
        pid: "A0126102"
    }, A0123613: {
        name: "Ceramide Micro Capsule Skin Replenishing Essence",
        brand: "Ceramide",
        desc: "Nourish, smooth and visibly clarify skin with a water-light, microencapsulated essence that prepares skin for rest of your beauty routine. In one week, 96% saw crystal clear skin with visibly improved texture and vitality.",
        size: "3.0 oz.",
        price: "63",
        pid: "A0123613"
    }, CERN40117: {
        name: "Ceramide Purifying Cream Cleanser",
        brand: "Ceramide",
        desc: "This creamy cleanser gently dissolves your makeup and other impurities while our Ceramide 3 complex calms and soothes your skin.",
        size: "4.2 oz.",
        price: "29.5",
        pid: "CERN40117"
    }, A0130794: {
        name: "Ceramide Replenishing Cleansing Oil",
        brand: "Ceramide",
        desc: "This luxurious oil dissolves all impurities and makeup while nourishing your skin with essential lipids, including Omega 3, 6 and 9 and Vitamin E.",
        size: "6.7 oz.",
        price: "36",
        pid: "A0130794"
    }, A0126100: {
        name: "Hyaluronic Acid Ceramide Capsules Hydra-Plumping Serum",
        brand: "Ceramide",
        desc: "Powered by Double-Lock Hydration, 98% see visibly plumper skin with a more youthful bounce. Moisture magnet hyaluronic acid and skin-strengthening ceramides work together to visibly plump, firm and hydrate skin",
        size: "90-Piece",
        price: "114",
        pid: "A0126100"
    }, A0119561: {
        name: "Hyaluronic Acid Ceramide Capsules Hydra-Plumping Serum",
        brand: "Ceramide",
        desc: "Powered by Double-Lock Hydration, 98% see visibly plumper skin with a more youthful bounce. Moisture magnet hyaluronic acid and skin-strengthening ceramides work together to visibly plump, firm and hydrate skin",
        size: "60-Piece",
        price: "92",
        pid: "A0119561"
    }, A0119563: {
        name: "Hyaluronic Acid Ceramide Capsules Hydra-Plumping Serum",
        brand: "Ceramide",
        desc: "Powered by Double-Lock Hydration, 98% see visibly plumper skin with a more youthful bounce. Moisture magnet hyaluronic acid and skin-strengthening ceramides work together to visibly plump, firm and hydrate skin",
        size: "30-Piece",
        price: "54",
        pid: "A0119563"
    }, A0133027: {
        name: "Retinol Ceramide Capsules Line Erasing Night Serum",
        brand: "Ceramide",
        desc: "76% more potent than unencapsulated retinol1--a new, targeted treatment to visibly diminish lines and wrinkles while improving skin texture and tone. Each capsule is single use and sealed tight for optimal freshness and potency. Plus, they're preservative and fragrance free. Smooth over face and neck each night before your moisturizer. Suitable for all skin types. Clinically and dermatologist tested.",
        size: "90-Piece",
        price: "114",
        pid: "A0133027"
    }, A0133024: {
        name: "Retinol Ceramide Capsules Line Erasing Night Serum",
        brand: "Ceramide",
        desc: "76% more potent than unencapsulated retinol1--a new, targeted treatment to visibly diminish lines and wrinkles while improving skin texture and tone. Each capsule is single use and sealed tight for optimal freshness and potency. Plus, they're preservative and fragrance free. Smooth over face and neck each night before your moisturizer. Suitable for all skin types. Clinically and dermatologist tested.",
        size: "60-Piece",
        price: "92",
        pid: "A0133024"
    }, A0133026: {
        name: "Retinol Ceramide Capsules Line Erasing Night Serum",
        brand: "Ceramide",
        desc: "76% more potent than unencapsulated retinol1--a new, targeted treatment to visibly diminish lines and wrinkles while improving skin texture and tone. Each capsule is single use and sealed tight for optimal freshness and potency. Plus, they're preservative and fragrance free. Smooth over face and neck each night before your moisturizer. Suitable for all skin types. Clinically and dermatologist tested.",
        size: "30-Piece",
        price: "54",
        pid: "A0133026"
    }, A0126296: {
        name: "Retinol Ceramide Line Erasing Eye Cream",
        brand: "Ceramide",
        desc: "A multi-benefit eye cream with clinically proven encapsulated retinol, peptides, niacinamide and moisture-boosting ceramides to smooth, brighten and de-puff for younger-looking eyes.",
        size: "0.5 oz.",
        price: "66",
        pid: "A0126296"
    }, A0119546: {
        name: "Vitamin C Ceramide Capsules Radiance Renewal Serum",
        brand: "Ceramide",
        desc: "178X more potent than traditional vitamin C1, this satiny dry oil serum helps to visibly brighten skin, even tone and protect against premature aging signs. See visibly brighter skin after just one use. Single-dose capsules. Travel friendly. Free from added fragranc",
        size: "90-Piece",
        price: "114",
        pid: "A0119546"
    }, A0119544: {
        name: "Vitamin C Ceramide Capsules Radiance Renewal Serum",
        brand: "Ceramide",
        desc: "178X more potent than traditional vitamin C1, this satiny dry oil serum helps to visibly brighten skin, even tone and protect against premature aging signs. See visibly brighter skin after just one use. Single-dose capsules. Travel friendly. Free from added fragranc",
        size: "60-Piece",
        price: "92",
        pid: "A0119544"
    }, A0119546: {
        name: "Vitamin C Ceramide Capsules Radiance Renewal Serum",
        brand: "Ceramide",
        desc: "178X more potent than traditional vitamin C1, this satiny dry oil serum helps to visibly brighten skin, even tone and protect against premature aging signs. See visibly brighter skin after just one use. Single-dose capsules. Travel friendly. Free from added fragranc",
        size: "30-Piece",
        price: "54",
        pid: "A0119546"
    }, PRVN40174: {
        name: "PREVAGE&reg; Anti-Aging Antioxidant Infusion Essence",
        brand: "PREVAGE&reg;",
        desc: "From Arden Active Skincare, this refreshing essence infuses skin with an advanced hydration and antioxidants.",
        size: "4.7 fl. oz.",
        price: "96",
        pid: "PRVN40174"
    }, A0124504: {
        name: "PREVAGE&reg; Anti-Aging Daily Serum 2.0",
        brand: "PREVAGE&reg;",
        desc: "Our #1 anti-aging serum, now with 4X the antioxidant power1. Harnessing the single most powerful antioxidant2, Idebenone, plus 10 new powerful ingredients, to help visibly reverse aging signs and protect against environmental damage for younger-looking skin.",
        size: "1.7 oz.",
        price: "169",
        pid: "A0124504"
    }, A0124507: {
        name: "PREVAGE&reg; Anti-Aging Daily Serum 2.0",
        brand: "PREVAGE&reg;",
        desc: "Our #1 anti-aging serum, now with 4X the antioxidant power1. Harnessing the single most powerful antioxidant2, Idebenone, plus 10 new powerful ingredients, to help visibly reverse aging signs and protect against environmental damage for younger-looking skin.",
        size: "1.0 oz.",
        price: "110",
        pid: "A0124507"
    }, A0102886: {
        name: "PREVAGE&reg; Anti-Aging Eye Serum",
        brand: "PREVAGE&reg;",
        desc: "This powerful eye serum targets dark circles and minimizes the appearance of fine lines, crow's feet and uneven skin tone.",
        size: "0.5 oz.",
        price: "106",
        pid: "A0102886"
    }, A0129747: {
        name: "PREVAGE&reg; Anti-Aging Eye Serum 2.0",
        brand: "PREVAGE&reg;",
        desc: "This powerful eye serum harnesses the power of Idebenone, the single most powerful antioxidant, to help protect against environmental damage, correct all visible eye aging signs and perfect the look of skin for a youthful glow.",
        size: "0.5 oz.",
        price: "106",
        pid: "A0129747"
    }, PRVN00101: {
        name: "PREVAGE&reg; Anti-aging Moisture Cream Broad Spectrum Sunscreen SPF 30",
        brand: "PREVAGE&reg;",
        desc: "This concentrated moisturizer with advanced Idebenone technology, helps nourish your skin's natural moisture defenses and reverse dryness while easing visible signs of aging and sun damage.",
        size: "1.7 oz.",
        price: "137",
        pid: "PRVN00101"
    }, A0135583: {
        name: "PREVAGE&reg; Anti-Aging Overnight Cream",
        brand: "PREVAGE&reg;",
        desc: "Treat visible signs of aging with our intensive overnight moisture cream, made to optimize your skin's natural repair process and minimize the look of lines, wrinkles and sun damage.",
        size: "1.7 oz.",
        price: "144",
        pid: "A0135583"
    }, PRVN40149: {
        name: "PREVAGE&reg; Anti-aging Treatment Boosting Cleanser",
        brand: "PREVAGE&reg;",
        desc: "This creamy, lightly-foaming cleanser preps your skin to get maximum benefits from your beauty regimen.",
        size: "4.2 fl. oz.",
        price: "52",
        pid: "PRVN40149"
    }, A0100498: {
        name: "PREVAGE&reg; City Smart Broad Spectrum SPF 50 Hydrating Shield",
        brand: "PREVAGE&reg;",
        desc: "The first-of-its-kind skin shield to keep skin looking younger and brighter. PREVAGE&reg; City Smart, a new level of skincare defense, combines pollution and UV protection with our DNA Enzyme Complex&trade; to strengthen skin.",
        size: "1.3 fl. oz.",
        price: "72",
        pid: "A0100498"
    }, A0116163: {
        name: "PREVAGE&reg; Progressive Renewal Treatment",
        brand: "PREVAGE&reg;",
        desc: "A new, intensive 4-week at-home face peeling treatment formulated to provide increasingly stronger resurfacing benefits, plus powerful antioxidant protection, to reveal smoother, brighter, younger-looking skin. Apply nightly after cleansing. Suitable for all skin types. Clinically and dermatologist tested.",
        size: "4 x .33 fl. oz.",
        price: "169",
        pid: "A0116163"
    }, A0136394: {
        name: "Visible Brightening Spot Correcting Night Capsules with Advanced MIx Concentrate&trade; II",
        brand: "Visible Brightening",
        desc: "Next-generation Visible Brightening Spot Correcting Night Capsules work with skin's natural repair process to diminish the number, size and intensity of dark spots, firm, and even tone. Wake up to younger-looking skin with a crystal-clear, translucent glow.",
        size: "60-Piece",
        price: "92",
        pid: "A0136394"
    }, A0101366: {
        name: "Elizabeth Arden SUPERSTART Skin Renewal Booster",
        brand: "SUPERSTART",
        desc: "Elizabeth Arden SUPERSTART Skin Renewal Booster helps restore the healthy look of skin's surface layer, fortifying its natural ability to repair and renew. Designed for Every Woman. Every Skin Type.",
        size: "1.7 oz.",
        price: "100",
        pid: "A0101366"
    }, STAN40001: {
        name: "Elizabeth Arden SUPERSTART Skin Renewal Booster",
        brand: "SUPERSTART",
        desc: "Elizabeth Arden SUPERSTART Skin Renewal Booster helps restore the healthy look of skin's surface layer, fortifying its natural ability to repair and renew. Designed for Every Woman. Every Skin Type.",
        size: "1.0 oz.",
        price: "70",
        pid: "STAN40001"
    }, A0133823: {
        name: "Visible Brightening CicaGlow Concentrate",
        brand: "Visible Brightening",
        desc: "A gentle, triple-action peel to brighten, smooth and soothe. This innovative bi-phase CicaGlow peel delivers advanced brightening benefits. Alcohol free. Non-comedogenic. Clinically and dermatologist tested.",
        size: "1.0 oz.",
        price: "70",
        pid: "A0133823"
    }, A0130785: {
        name: "Visible Difference Replenishing HydraGel Complex",
        brand: "Visible Difference",
        desc: "Hydration Hero. This refreshing, oil-free water gel is formulated to plump skin with 24-hour hydration and refine the look of pores.",
        size: "2.6 oz.",
        price: "58",
        pid: "A0130785"
    }
}, dscRecs = {
    "darkcircles-4": "A0102886",
    "darkcircles-3": "A0102886",
    "darkcircles-2": "A0126296",
    "darkcircles-1": "A0107303",
    "spots-4": "A0124504",
    "spots-3": "A0133823",
    "spots-2": "A0119546",
    "spots-1": "A0133823",
    "texture-4": "A0116163",
    "texture-3": "A0133823",
    "texture-2": "A0119561",
    "texture-1": "A0101366",
    "wrinkles-4": "A0133027",
    "wrinkles-3": "A0133027",
    "wrinkles-2": "A0124504",
    "wrinkles-1": "A0104589",
    "firmness-4": "A0124504",
    "firmness-3": "A0104589",
    "firmness-2": "A0127779",
    "firmness-1": "A0119561"
};
//# sourceMappingURL=/s/files/1/0697/1690/2208/files/diagnose-skin-concerns-regimens.js.map?v=1691085030
